import React, { useState } from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";

import { Modal } from "@lib/modal";
import { ISOToDisplayCode } from "@utils";
import { Button } from "@components/buttons";
import { CashoutStore } from "@state/stores/my-bets/CashoutStore";
import { CashoutLocation } from "@utils/common/cashoutLocation";
import { OpenCashoutModalType } from "@data-types/my-bets/OpenCashoutModal";
import { THEME_SETTINGS } from "@theme-settings";
import { useFixBody } from "@state/hooks/shared";

export default observer(function CashoutConfirmation(props: {
	cashoutModalData: OpenCashoutModalType | null;
	onClose: () => void;
	onAccept: CashoutStore["cashout"];
	isSubmitting?: boolean;
	isOpen?: boolean;
}) {
	useFixBody(true, props.isOpen);
	const { t } = useTranslation();

	const [acceptChangeRef, setAcceptChangeRef] =
		useState<HTMLInputElement | null>();

	if (!props.isOpen) {
		return null;
	}

	if (props.cashoutModalData == null) {
		return null;
	}

	return (
		<Modal>
			<div className="popup">
				<div className="popup__card popup__card--med">
					<div className="popup__header">
						{t("mybets:CASHOUT.TITLE")}
					</div>
					<div className="popup__body">
						{props.cashoutModalData.message != undefined ? (
							<div className="message--base message--warning">
								{props.cashoutModalData.message}
							</div>
						) : (
							<div>
								{t("mybets:CASHOUT.MESSAGE", {
									amount: props.cashoutModalData
										.displayedAmount,
									currency: ISOToDisplayCode(
										THEME_SETTINGS.defaultCurrency
									),
								})}
							</div>
						)}
						<div className="input--check u-mar--top--xsml">
							<input
								id="isChangeAccepted"
								className="input--check__box"
								ref={(newRef) => setAcceptChangeRef(newRef)}
								disabled={props.isSubmitting}
								type="checkbox"
							/>
							<label
								htmlFor="isChangeAccepted"
								className="input--check__label"
							>
								{t("mybets:CASHOUT.ACCEPT_CHANGED_AMOUNT")}
							</label>
						</div>
					</div>
					<div className="popup__footer">
						<button
							className="popup__btn btn btn--med btn--primary--inverted"
							disabled={props.isSubmitting}
							onClick={props.onClose}
							type="button"
						>
							{t("COMMON.CANCEL")}
						</button>
						<Button
							className="popup__btn btn btn--med btn--cashout"
							disabled={props.isSubmitting}
							onClick={() => {
								if (props.cashoutModalData) {
									props.onAccept(
										{
											id: props.cashoutModalData.id,
											calculatedCashoutAmount:
												props.cashoutModalData
													.calculatedCashoutAmount,
											cType: props.cashoutModalData.cType,
											isChangeAccepted:
												acceptChangeRef?.checked ||
												false,
											isLive: props.cashoutModalData
												.isLive,
											displayedAmount:
												props.cashoutModalData
													.displayedAmount,
											userId: props.cashoutModalData
												.userId,
											liveBetSlipCountdown:
												props.cashoutModalData
													.liveBetSlipCountdown,
										},
										CashoutLocation.MY_BETS
									);
								}
							}}
							type="submit"
							btnText={t("mybets:CASHOUT.TITLE")}
						></Button>
					</div>
				</div>
			</div>
		</Modal>
	);
});
